import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import type { IAssetsTemperature } from '../model/IAssetsTemperature';

interface IAssetsTemperatureKeys {
  refreshInterval: string;
  locationIds?: Array<number>;
}

export const assetsTemperatureKey = (keys: IAssetsTemperatureKeys) => [
  'assetsTemperature',
  keys.refreshInterval,
  keys?.locationIds,
];

export const assetsTemperatureFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof assetsTemperatureKey>>) => {
  const params = {
    filters: {
      locationIds: queryKey[2],
    },
  };

  return apiClient.get(`${APP_API_URL_V2}fsd/locations/temperature-assets`, {
    params,
  });
};

const assetsTemperatureSelect = ({ data }: AxiosResponse<{ data: Array<IAssetsTemperature> }>) =>
  data?.data || [];

export const useAssetsTemperatureQuery = (keys: IAssetsTemperatureKeys) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: assetsTemperatureKey(keys),
    queryFn: assetsTemperatureFn,
    select: assetsTemperatureSelect,
    refetchInterval: keys.refreshInterval,
    refetchIntervalInBackground: true,
  });
};
